function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import math from 'polished/lib/math/math';
import typography from '../utils/typography';
import nativeFocus from '../utils/native_focus';
import { useTheme } from '@veneer/theme';
var useStyles = _ref => {
  var {
    expanded,
    hoverable,
    noWrap,
    short,
    showIcon,
    vertical
  } = _ref;
  var theme = useTheme();
  return React.useMemo(() => {
    var iconSize = theme.layout.size6;
    var isHc = theme.mode === 'contrast';
    var sideMenuLabel = '> .vn-side-menu__item-col-icon, > .vn-side-menu__item-col-label, > .vn-side-menu__item-col-toggle';
    return {
      root: {
        whiteSpace: 'nowrap',
        minWidth: '40px',
        'a:hover, a:focus, a:active': {
          textDecoration: 'none'
        },
        '> .vn-side-menu__item-link': _objectSpread(_objectSpread({
          alignItems: 'center',
          boxSizing: 'border-box',
          color: theme.palette.foreground.default,
          cursor: 'pointer',
          display: 'flex',
          transition: 'color 300ms ease, background-color 300ms ease, border-color 300ms ease',
          userSelect: 'none'
        }, isHc && {
          color: theme.palette.primary.default
        }), {}, {
          '> .vn-side-menu__item-col-label': _objectSpread(_objectSpread({
            display: short ? 'none' : 'block',
            flexGrow: 1,
            whiteSpace: 'normal'
          }, noWrap && {
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
          }), vertical && {
            textAlign: 'center',
            textOverflow: 'clip',
            whiteSpace: 'normal'
          }),
          '> .vn-side-menu__item-col-icon': {
            minWidth: iconSize
          }
        })
      },
      primary: _objectSpread(_objectSpread({}, typography(theme).label), {}, {
        margin: theme.layout.size2,
        transition: 'margin 500ms ease',
        a: _objectSpread({}, nativeFocus(theme)),
        '&:last-of-type': {
          marginBottom: 0
        },
        '> .vn-side-menu__item-link': _objectSpread(_objectSpread(_objectSpread({
          borderRadius: theme.borderRadius3,
          padding: theme.layout.size2
        }, vertical && {
          flexDirection: 'column',
          padding: theme.layout.size1
        }), {}, {
          '> .vn-side-menu__item-col-label': !showIcon && {
            margin: "calc(".concat(theme.layout.size1, " / 2) 0"),
            marginLeft: theme.layout.size1
          },
          '&[data-selected]': _objectSpread({
            backgroundColor: !vertical ? theme.palette.primary.background : undefined,
            color: theme.palette.primary.active
          }, vertical && {
            '> .vn-side-menu__item-col-icon': {
              backgroundColor: theme.palette.primary.background
            }
          })
        }, hoverable && {
          '&:hover:not([data-selected]):not(:active)': _objectSpread(_objectSpread({
            backgroundColor: !vertical ? theme.palette.neutral.backgroundLight : undefined
          }, sideMenuLabel && {
            color: theme.palette.foreground.default
          }), vertical && {
            '> .vn-side-menu__item-col-icon': {
              backgroundColor: theme.palette.neutral.backgroundLight,
              color: theme.palette.foreground.default
            },
            '> .vn-side-menu__item-col-label': {
              color: theme.palette.foreground.default
            }
          })
        }), {}, {
          '&:active:not([data-selected])': _objectSpread(_objectSpread({
            backgroundColor: !vertical ? theme.palette.neutral.background : undefined
          }, sideMenuLabel && {
            color: theme.palette.foreground.default
          }), vertical && {
            '> .vn-side-menu__item-col-icon': {
              backgroundColor: theme.palette.neutral.background
            },
            '> .vn-side-menu__item-col-label': {
              color: theme.palette.foreground.default
            }
          })
        }, isHc && _objectSpread(_objectSpread({
          '&[data-selected]': _objectSpread({
            backgroundColor: !vertical ? theme.palette.primary.active : undefined,
            color: !vertical ? theme.palette.foreground.inverse : theme.palette.primary.active
          }, vertical && {
            '> .vn-side-menu__item-col-icon': {
              backgroundColor: theme.palette.primary.active,
              color: theme.palette.foreground.inverse
            }
          })
        }, hoverable && {
          '&:hover:not([data-selected]):not(:active)': _objectSpread(_objectSpread({
            backgroundColor: !vertical ? theme.palette.primary.hover : undefined
          }, sideMenuLabel && {
            color: theme.palette.foreground.inverse
          }), vertical && {
            '> .vn-side-menu__item-col-icon': {
              backgroundColor: theme.palette.primary.hover,
              color: theme.palette.foreground.inverse
            },
            '> .vn-side-menu__item-col-label': {
              color: theme.palette.primary.hover
            }
          })
        }), {}, {
          '&:active:not([data-selected])': _objectSpread(_objectSpread({
            backgroundColor: !vertical ? theme.palette.primary.active : undefined
          }, sideMenuLabel && {
            color: theme.palette.foreground.inverse
          }), vertical && {
            '> .vn-side-menu__item-col-icon': {
              backgroundColor: theme.palette.primary.active
            },
            '> .vn-side-menu__item-col-label': {
              color: theme.palette.primary.active
            }
          })
        })),
        ul: {
          marginTop: theme.layout.size1,
          paddingLeft: theme.layout.size5,
          paddingRight: theme.layout.size1
        }
      }),
      icon: _objectSpread(_objectSpread({
        alignItems: 'center',
        display: 'inline-flex',
        height: theme.layout.size6,
        justifyContent: 'center',
        marginRight: !(short || vertical) ? theme.layout.size2 : undefined,
        width: theme.layout.size6
      }, vertical && {
        backgroundColor: 'transparent',
        borderRadius: theme.borderRadius4,
        height: 48,
        marginBottom: theme.layout.size1,
        transition: 'background-color 150ms linear',
        width: 48
      }), {}, {
        '> svg': _objectSpread({
          color: 'inherit'
        }, vertical && {
          height: theme.layout.size8,
          width: theme.layout.size8
        }),
        '> img': {
          borderRadius: '50%',
          height: vertical ? theme.layout.size8 : theme.layout.size5,
          width: vertical ? theme.layout.size8 : theme.layout.size5
        }
      }),
      toggleButton: {
        display: short ? 'none' : 'inline-flex',
        height: theme.layout.size6,
        marginLeft: theme.layout.size2,
        width: theme.layout.size6,
        '> svg': {
          color: 'inherit',
          transform: expanded ? 'rotate(-180deg)' : 'rotate(0)',
          transition: 'transform 0.5s ease'
        }
      },
      secondary: _objectSpread(_objectSpread({
        borderLeft: "2px solid ".concat(theme.palette.neutral.backgroundLight)
      }, typography(theme).body), {}, {
        padding: "".concat(theme.layout.size1, " 0 ").concat(theme.layout.size1, " ").concat(math("".concat(theme.layout.size4, " + 2px"))),
        position: 'relative',
        '> .vn-side-menu__item-link': _objectSpread(_objectSpread({
          '&[data-selected]': {
            color: isHc ? theme.palette.primary.active : theme.palette.primary.default,
            '::before': {
              backgroundColor: isHc ? theme.palette.primary.active : theme.palette.primary.default,
              bottom: 0,
              content: '" "',
              height: theme.typography.lineHeight3,
              left: '-2px',
              position: 'absolute',
              top: '50%',
              transform: 'translateY(-50%)',
              width: 2
            }
          }
        }, hoverable && {
          '&:hover:not([data-selected]):not(:active)': {
            color: theme.palette.primary.hover
          }
        }), {}, {
          '&:active:not([data-selected])': {
            color: theme.palette.primary.active
          }
        })
      })
    };
  }, [expanded, hoverable, noWrap, short, showIcon, theme, vertical]);
};
export default useStyles;